export default __webpack_public_path__ + "static/media/seafood.ac3d28af.jpg";